<script setup lang="ts">
// import footer01Url from "./footer-01.svg"
// import footer02Url from "./footer-02.svg"
// import footer03Url from "./footer-03.svg"
// import footer04Url from "./footer-04.svg"
// import footer05Url from "./footer-05.svg"
// import tertiaryFooterBg from "./footer-tertiary.png"
import footerBakUrl from "./footer_bak.jpg"
import footerLegalUrl from "./footer_legal.jpg"
import footerQmUrl from "./footer_qm.jpg"

const year = new Date().getFullYear()
</script>

<template>
    <!-- <div class="page-tertiary-footer" :style="{ backgroundImage: `url(${tertiaryFooterBg})` }"> -->
    <!--     <div class="footer-item"> -->
    <!--         <img :src="footer01Url" /> -->
    <!--         <div>Labor Qualität</div> -->
    <!--     </div> -->
    <!---->
    <!--     <div class="footer-item"> -->
    <!--         <img :src="footer02Url" /> -->
    <!--         <div>Arzneimittel Zulassung</div> -->
    <!--     </div> -->
    <!---->
    <!--     <div class="footer-item"> -->
    <!--         <img :src="footer03Url" /> -->
    <!--         <div>Premium Upgrade</div> -->
    <!--     </div> -->
    <!---->
    <!--     <div class="footer-item"> -->
    <!--         <img :src="footer04Url" /> -->
    <!--         <div>Hohe Sicherheit</div> -->
    <!--     </div> -->
    <!---->
    <!--     <div class="footer-item"> -->
    <!--         <img :src="footer05Url" /> -->
    <!--         <div>Schnelle Lieferung</div> -->
    <!--     </div> -->
    <!-- </div> -->

    <footer class="page-secondary-footer" aria-label="Footer">
        <div class="row">
            <div class="col-md-3">
                <h1>CANN24</h1>

                <p aria-label="Adresse">
                    apotheke am inselpark
                    <br />
                    Neuenfelder Str. 31 &middot; 21109 Hamburg
                    <br />
                    Hotline 040 30 23 86 99 24
                </p>

                <!--                <div class="d-flex justify-content-between" style="gap: 1rem">-->
                <!--                    <img src="../../static/icons/payment/visa.svg" alt="Visa">-->
                <!--                    <img src="../../static/icons/payment/paypal.svg" alt="Paypal">-->
                <!--                    <img src="../../static/icons/payment/mastercard.svg" alt="Mastercard">-->
                <!--                    <img src="../../static/icons/payment/klarna.svg" alt="Karna">-->
                <!--                    <img src="../../static/icons/payment/maestro.svg" alt="Maestro">-->
                <!--                </div>-->
            </div>
            <div class="col-md-6">
                <h1>Einfach &amp; Sicher</h1>

                <p aria-label="Sicherer Versand">
                    Wir möchten dir den Erwerb deiner Arzneimittel so einfach wie möglich machen und versenden als
                    zertifizierte Versandapotheke deine Bestellung per Über-Nacht-Express an deine Adresse.
                </p>

                <div aria-label="Kennzeichnungen">
                    <img :src="footerQmUrl" width="113" height="80" alt="QM" class="mr-4 mb-3 img-fluid" />
                    <a
                        aria-label="Überprüfung der Legalität"
                        href="https://versandhandel.dimdi.de/websearch/servlet/Gate?accessid=dimdi_var&term=849ab145e8b9799dd81f0f65cb83f8fc"
                        target="_blank"
                    >
                        <img :src="footerLegalUrl" width="96" height="80" alt="" class="mr-4 mb-3 img-fluid" />
                    </a>
                    <img :src="footerBakUrl" width="242" height="80" alt="BAK" class="mr-4 mb-3 img-fluid" />
                </div>
            </div>
            <div class="col-md-3">
                <h1>Informationen</h1>

                <ul class="slim-ul" role="list" aria-label="Weitere Informationen">
                    <li>
                        <RouterLink :to="{ name: 'faq' }">FAQ</RouterLink>
                    </li>
                    <li>
                        <RouterLink :to="{ name: 'id-check' }">Patienten-ID prüfen</RouterLink>
                    </li>
                    <li>
                        <RouterLink :to="{ name: 'legal-imprint' }">Impressum</RouterLink>
                    </li>
                    <li>
                        <RouterLink :to="{ name: 'legal-data-privacy' }">Datenschutzerklärung</RouterLink>
                    </li>
                    <li>
                        <RouterLink :to="{ name: 'legal-revocation' }">Widerrufsbelehrung</RouterLink>
                    </li>
                    <li>
                        <RouterLink :to="{ name: 'legal-toc' }">AGB</RouterLink>
                    </li>
                    <li>
                        <RouterLink :to="{ name: 'accessibility' }">Barrierefreiheit</RouterLink>
                    </li>
                </ul>
                <div class="mt-2">
                    <RouterLink :to="{ name: 'revoke-order' }" class="btn btn-warning">Vertrag widerrufen</RouterLink>
                </div>
            </div>
        </div>
    </footer>
    <div class="page-footer" aria-label="Copyright">
        &copy; Copyright {{ year }} apotheke am inselpark e.K. Alle Rechte vorbehalten.
    </div>
</template>
<style scoped>
li a {
    color: #80b7af !important;
}
</style>
